module.exports = __webpack_public_path__ + "static/media/Logo.60438187.png";